<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item class="title" lines="none">
    <ion-label>
      <h3>{{ evaluation.title }}</h3>
      @if (evaluation.description) {
      <p>{{ evaluation.description }}</p>
      }
    </ion-label>
  </ion-item>

  @for (question of evaluation.questions; track question.id) { @if (question.type === EvaluationQuestionTypeIds.Stars) {
  <ion-row class="stars">
    <h2 class="question">{{ question.question }}</h2>
    @for (star of question.stars; track $index) {
    <ion-col>
      <ion-button mode="ios" expand="block" (click)="!readOnly && (question.value = star.evaluationValue)">
        <ion-icon slot="icon-only" src="assets/images/evaluation/star{{ +question.value >= star.evaluationValue ? '-selected' : '' }}.svg"></ion-icon>
      </ion-button>
    </ion-col>
    }
  </ion-row>
  } @if (question.type === EvaluationQuestionTypeIds.Text && !question.hidden) {
  <ion-row class="text">
    <h2 class="question">{{ question.question }}</h2>
    <ion-item lines="none">
      <ion-textarea type="text" [(ngModel)]="question.value" [rows]="3" [autoGrow]="true" [readonly]="readOnly"></ion-textarea>
    </ion-item>
  </ion-row>
  } @if (question.type === EvaluationQuestionTypeIds.NetPromoterScore) {
  <ion-row class="nps">
    <h2 class="question">{{ question.question }}</h2>
    <div class="nps-circles-wrapper">
      @for (num of [0,1,2,3,4,5,6,7,8,9,10]; track num) {
      <div class="nps-circle" [class.selected]="question.value == num" [attr.data-num]="num" (click)="!readOnly && (question.value = num)">
        {{ num }}
      </div>
      }
    </div>
  </ion-row>
  } @if (question.type === EvaluationQuestionTypeIds.Dropdown) {
  <ion-row class="dropdown">
    <h2 class="question">{{ question.question }}</h2>
    <ion-item lines="none" class="ion-select-with-custom-icon">
      <ion-select
        interface="popover"
        toggleIcon="assets/images/common/arrow-down.svg"
        [(ngModel)]="question.value"
        (ionChange)="onDropdownQuestionChanged(question)"
        [disabled]="readOnly"
        [placeholder]="translation.Common.Select | translate">
        @for (opt of question.options; track opt.id) {
        <ion-select-option [value]="opt.id">{{ opt.text }}</ion-select-option>
        }
      </ion-select>
      <ion-icon slot="end" src="assets/images/common/arrow-down.svg"></ion-icon>
    </ion-item>
    @if (question.isOtherOptionSelected) {
    <ion-item lines="none">
      <ion-textarea
        type="text"
        [(ngModel)]="question.otherOptionValue"
        [placeholder]="translation.Common.WriteTheReason | translate"
        [rows]="3"
        [autoGrow]="true"
        [readonly]="readOnly"></ion-textarea>
    </ion-item>
    }
  </ion-row>
  } @if (question.type === EvaluationQuestionTypeIds.Choices) {
  <ion-row class="choices">
    <h2 class="question">{{ question.question }}</h2>
    <div class="choices-wrapper">
      @for (choice of question.options; track choice.id; let i = $index) {
      <ion-button fill="outline" [class.selected]="question.value === choice.id" [attr.data-num]="i + 1" (click)="!readOnly && selectChoice(question, i)">
        {{ choice.text }}
      </ion-button>
      }
    </div>
  </ion-row>
  } }
</ion-content>

@if (!readOnly) {
<ion-footer class="ion-no-border">
  <ion-row>
    <ion-col class="ion-no-padding">
      <ion-button expand="block" (click)="submit()" [disabled]="!canSubmit()">{{ translation.Common.Continue | translate }}</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
}
